// i18nOwl-ignore [app-cohort.triggerIntegrations.perk-used.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortPerkUsedTriggerkIntegrationConfigComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/perkUsed/ConfigComponent';
import CohortPerkUsedTriggerIntegrationStepCompletionComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/perkUsed/StepCompletionComponent';
import type {CohortPerkUsedTriggerStruct} from '@cohort/shared/schema/apps/cohort/triggers/perkUsed';
import {CohortPerkUsedTriggerIntegrationSpec} from '@cohort/shared/schema/apps/cohort/triggers/perkUsed';

export const CohortPerkUsedTriggerIntegration: TriggerIntegration<CohortPerkUsedTriggerStruct> = {
  spec: CohortPerkUsedTriggerIntegrationSpec,
  configComponent: CohortPerkUsedTriggerkIntegrationConfigComponent,
  stepCompletionComponent: CohortPerkUsedTriggerIntegrationStepCompletionComponent,
};
